import { render, staticRenderFns } from "./tables.vue?vue&type=template&id=20731161&scoped=true&"
import script from "./tables.vue?vue&type=script&lang=js&"
export * from "./tables.vue?vue&type=script&lang=js&"
import style0 from "./tables.vue?vue&type=style&index=0&id=20731161&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20731161",
  null
  
)

export default component.exports